// ACTIONS
export const FETCH = 'offerzen/jobExperiences/FETCH'
const FETCH_SUCCESS = 'offerzen/jobExperiences/FETCH_SUCCESS'
const FETCH_ERROR = 'offerzen/jobExperiences/FETCH_ERROR'

export const DELETE = 'offerzen/jobExperiences/DELETE'
const DELETE_SUCCESS = 'offerzen/jobExperiences/DELETE_SUCCESS'
const DELETE_ERROR = 'offerzen/jobExperiences/DELETE_ERROR'

export const CREATE = 'offerzen/jobExperiences/CREATE'
const CREATE_SUCCESS = 'offerzen/jobExperiences/CREATE_SUCCESS'
const CREATE_ERROR = 'offerzen/jobExperiences/CREATE_ERROR'

export const UPDATE = 'offerzen/jobExperiences/UPDATE'
const UPDATE_SUCCESS = 'offerzen/jobExperiences/UPDATE_SUCCESS'
const UPDATE_ERROR = 'offerzen/jobExperiences/UPDATE_ERROR'

const ADD_TEMP_ITEM = 'offerzen/jobExperiences/ADD_TEMP_ITEM'
const DELETE_TEMP_ITEM = 'offerzen/jobExperiences/DELETE_TEMP_ITEM'

const TOGGLE_EDIT = 'offerzen/jobExperiences/TOGGLE_EDIT'

export const SUBMIT = 'offerzen/jobExperiences/SUBMIT'

// FETCH CREATORS
export const fetchJobExperiences = id => ({
  type: FETCH,
  meta: { id },
  payload: {
    fetching: true,
  },
})

export const fetchJobExperiencesSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    data,
    fetching: false,
  },
})

export const fetchJobExperiencesError = errorMessage => ({
  type: FETCH_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const createJobExperience = (candidateId, data, resolve, reject) => ({
  type: CREATE,
  meta: { candidateId, data, resolve, reject },
})

export const createJobExperienceSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: data,
})

export const createJobExperienceError = errorMessage => ({
  type: CREATE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const deleteJobExperience = id => ({
  type: DELETE,
  meta: { id },
})

export const deleteJobExperienceSuccess = id => ({
  type: DELETE_SUCCESS,
  payload: { id },
})

export const deleteJobExperienceError = errorMessage => ({
  type: DELETE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const updateJobExperience = (data, resolve, reject) => ({
  type: UPDATE,
  meta: { data, resolve, reject },
})

export const updateJobExperienceSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: data,
})

export const updateJobExperienceError = errorMessage => ({
  type: UPDATE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

/*
 ** `tempId` is used as a unique identifier for new instances of JobExperienceItemForm,
 ** only records that have not been persisted to the database will use `tempId`, those
 ** that have will use an `id` instead
 */
export const addBlankJobExperienceItem = tempId => ({
  type: ADD_TEMP_ITEM,
  payload: {
    tempId,
    editing: true,
    isNew: true,
  },
})

export const deleteBlankJobExperienceItem = tempId => ({
  type: DELETE_TEMP_ITEM,
  payload: { tempId },
})

export const toggleJobExperienceEdit = (id, editing) => ({
  type: TOGGLE_EDIT,
  payload: { id, editing },
})

export const submit = (data, resolve, reject) => ({
  type: SUBMIT,
  meta: { resolve, reject },
  payload: { data },
})

// REDUCERS
const initialJobExperience = {
  editing: false,
  isNew: false,
}

const jobExperience = (state = initialJobExperience, type, payload) => {
  switch (type) {
    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return {
        ...state,
        ...payload,
      }

    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
      if (state.id !== payload.id) return state

      return {
        ...state,
        ...payload,
      }

    default:
      return state
  }
}

const initialState = {
  fetching: true,
  data: [],
  error: null,
}

const entities = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case FETCH:
      return { ...state, ...payload }

    case FETCH_SUCCESS:
      return {
        ...state,
        fetching: payload.fetching,
        data: payload.data.map(experience => jobExperience(experience, type, payload)),
      }

    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return {
        ...state,
        data: [...state.data, jobExperience(undefined, type, payload)],
      }

    case DELETE_TEMP_ITEM:
      return {
        ...state,
        data: state.data.filter(experience => experience.tempId !== payload.tempId),
      }

    case DELETE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(experience => experience.id !== payload.id),
      }

    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
      return {
        ...state,
        data: state.data.map(experience => jobExperience(experience, type, payload)),
      }

    case FETCH_ERROR:
    case CREATE_ERROR:
    case DELETE_ERROR:
    case UPDATE_ERROR:
      return { ...state, loading: false, error: payload }

    default:
      return state
  }
}

export default entities

export const getJobExperiences = state => state.jobExperiences || initialState
